<template>
  <div class="article-create">
    <articles-form
      v-if="!isLoading"
      :data="article"
      :channels="channels"
      :header="article.title || 'Untitled'"
    />
    <div v-else class="article-create__loader">
      <loading-icon
        :loading="isLoading"
        loading-class="text-center vertical-middle"
      />
    </div>
  </div>
</template>

<script>
import ArticlesForm from './form/Form'

export default {
  name: 'EditArticle',

  components: {
    ArticlesForm,
  },

  data() {
    return {
      article: null,
      channels: [],
      isLoading: true,
    }
  },

  created() {
    this.getData()
  },

  methods: {
    async getData() {
      const { articleId } = this.$route.params
      const { data: articleData } = await this.$http.get(
        `/articles/${articleId}`
      )

      this.article = articleData.data
      this.article.analyst = this.article.analysts[0]
      // this.article.companies = this.article.companies.map((company) => {
      //   const recommendation = this.article.company_recommendations.find((r) => r.company.id === company.id) || {}
      //   // recommendation.name = recommendation.recommendation.name
      //   // recommendation.id = recommendation.recommendation.id
      //   company.recommendation = recommendation
      //   company.security = recommendation.security ? recommendation.security.display_name : null
      //   company.security_id = recommendation.security ? recommendation.security.id : null
      //   return company
      // })
      this.article.bonds = this.article.company_recommendations.reduce(
        (items, r) => {
          // if (!this.article.companies.find((c) => c.recommendation && c.recommendation.id === r.id)) {
          if (r.bond_isin) {
            const rec = {
              ...r.company,
              id: r.id,
              objectID: r.id,
              recommendation: r,
              isin: r.bond_isin,
              description: r.bond_isin,
            }
            items.push(rec)
          }
          return items
          // }
        },
        []
      )
      this.article.companies = this.article.company_recommendations.reduce(
        (items, r) => {
          if (r.company) {
            const rec = {
              ...r.company,
              recommendation: r,
              security: r.security ? r.security.display_name : null,
              security_id: r.security ? r.security.id : null,
            }
            items.push(rec)
          }
          return items
        },
        []
      )
      this.article.channel = this.article.channel_content_type.channel
      this.isLoading = false
    },

    setCompanies() {
      const { article } = this

      const companies = article.company_recommendations
        .filter(({ company = false }) => company)
        .map((recc) => {
          const mappedCompany = {
            recommendation: {},
          }

          // eslint-disable-next-line camelcase
          const { id, company, target_price, currency, recommendation } = recc

          // eslint-disable-next-line camelcase
          if (target_price) {
            mappedCompany.recommendation.target_price =
              recommendation.target_price
          }

          if (currency) {
            mappedCompany.recommendation.target_price_currency = currency
            mappedCompany.recommendation.target_price_currency_id = currency.id
          }

          return {
            recommendation,
            id: company.id,
            name: company.name,
            company_recommendation_id: id,
            tag_id: company.tag_id,
            country: company.country,
          }
        })
    },
  },
}
</script>

<style lang="scss"></style>
